import { useEffect, useRef, useState } from "react";
import useReveal from "@/hooks/useReveal";
import { stats } from "@/lib/home-content";

function Counter({ value, prefix, suffix, decimals, start }) {
    const [n, setN] = useState(0);
    const raf = useRef(null);

    useEffect(() => {
        if (!start) return undefined;
        const duration = 1600;
        const t0 = performance.now();
        const tick = (now) => {
            const p = Math.min((now - t0) / duration, 1);
            const eased = p === 1 ? 1 : 1 - Math.pow(2, -10 * p);
            setN(value * eased);
            if (p < 1) raf.current = requestAnimationFrame(tick);
        };
        raf.current = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf.current);
    }, [start, value]);

    const display = n.toLocaleString("en-CA", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });

    return (
        <span>
            {prefix}
            {display}
            {suffix}
        </span>
    );
}

export default function AnimatedStats() {
    const { ref, visible } = useReveal({ threshold: 0.3 });
    return (
        <section className="bg-[#0a0a0f] py-12 sm:py-14">
            <div ref={ref} className="mx-auto grid max-w-5xl grid-cols-2 gap-x-4 gap-y-8 px-5 md:grid-cols-4">
                {stats.items.map((s) => (
                    <div key={s.label} className="text-center">
                        <div className="font-display text-4xl font-extrabold leading-none text-white sm:text-5xl">
                            {s.display ? s.display : <Counter {...s} start={visible} />}
                        </div>
                        <div className="mt-2 text-xs font-medium uppercase tracking-wide text-white/55 sm:text-sm">
                            {s.label}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
